import { useState, useMemo } from 'react';

const usePagination = (data, itemsPerPage = 10) => {
  const [currentPage, setCurrentPage] = useState(0);

  // Calculate pagination values
  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  
  // Get current page data
  const currentData = useMemo(() => {
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  }, [data, currentPage, itemsPerPage]);

  // Handle page change
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Reset to first page when data changes
  const resetPage = () => {
    setCurrentPage(0);
  };

  // Check if pagination should be shown (more than itemsPerPage items)
  const shouldShowPagination = totalItems > itemsPerPage;

  return {
    currentPage,
    totalPages,
    totalItems,
    currentData,
    handlePageChange,
    resetPage,
    shouldShowPagination,
    itemsPerPage
  };
};

export default usePagination;